/**
 * dm-gal Image Grouping by Alt Tag — Hardened v3
 * ------------------------------------------------
 * Alt tag rule: use # + variant name with NO spaces
 * e.g. "Antique Gold" → #antiquegold
 *      "Antique Brass#Small" → #antiquebrass#small
 */

(function () {
  'use strict';

  // ── CONFIG ────────────────────────────────────────────────────────
  const MATCH_MODE  = 'ALL';         // 'ANY' or 'ALL'
  const GALLERY_ID  = 'dmGal';
  const RETRY_DELAY = [30, 100, 300]; // ms — retries after variant change
  // ─────────────────────────────────────────────────────────────────

  // Normalize: lowercase + strip all whitespace
  // "Antique Gold" → "antiquegold"
  function normalize(str) {
    return (str || '').trim().toLowerCase().replace(/\s+/g, '');
  }

  // ── ALT TAG PARSER ───────────────────────────────────────────────
  // "#antiquegold#small" → ["antiquegold", "small"]
  // "#antique gold"      → ["antiquegold"]  (spaces stripped after parse)
  // "lifestyle shot"     → []  (no # → always show)
  function parseAltTags(alt) {
    if (!alt) return [];
    const matches = alt.match(/#[^#]+/g);
    if (!matches) return [];
    return matches.map(t => normalize(t.slice(1)));
  }

  // ── READ SELECTED OPTIONS ────────────────────────────────────────
  function getSelectedOptions() {
    const values = new Set();

    function addValue(v) {
      if (v) values.add(normalize(v));
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantEl = productForm.querySelector('variant-selects, variant-radios');
      if (variantEl) {
        variantEl.querySelectorAll('input[type="radio"]:checked').forEach(el => addValue(el.value));
        variantEl.querySelectorAll('select').forEach(el => addValue(el.value));
      }
    }

    // Fallback: scan whole page
    if (values.size === 0) {
      document.querySelectorAll(
        'variant-selects input[type="radio"]:checked, ' +
        'variant-radios input[type="radio"]:checked'
      ).forEach(el => addValue(el.value));

      document.querySelectorAll(
        'variant-selects select, variant-radios select'
      ).forEach(el => addValue(el.options[el.selectedIndex]?.value));
    }

    return [...values];
  }

  // ── VISIBILITY LOGIC ─────────────────────────────────────────────
  function shouldShow(altText, selectedOptions) {
    const tags = parseAltTags(altText);
    if (tags.length === 0) return true;            // untagged → always show
    if (selectedOptions.length === 0) return true; // nothing selected → show all

    return MATCH_MODE === 'ALL'
      ? tags.every(tag => selectedOptions.includes(tag))
      : tags.some(tag => selectedOptions.includes(tag));
  }

  // ── FILTER GALLERY ───────────────────────────────────────────────
  function filterGallery() {
    const gallery = document.getElementById(GALLERY_ID);
    if (!gallery) return;

    const selectedOptions = getSelectedOptions();
   // console.log('[dmGal] Selected options:', selectedOptions); // remove after testing

    const slides = [...gallery.querySelectorAll('.dm-gal__slide')];
    const thumbs = [...gallery.querySelectorAll('.dm-gal__thumb')];

    let firstVisibleIndex = -1;

    slides.forEach((slide, i) => {
      const img  = slide.querySelector('img[alt]');
      const alt  = img ? img.getAttribute('alt') : '';
      const show = shouldShow(alt, selectedOptions);

      slide.style.display = show ? '' : 'none';
      if (thumbs[i]) thumbs[i].style.display = show ? '' : 'none';

      if (show && firstVisibleIndex === -1) firstVisibleIndex = i;
    });

    if (firstVisibleIndex !== -1 && typeof dmGalSelect === 'function') {
      dmGalSelect(firstVisibleIndex);
    }
  }

  // ── RETRY FILTER ─────────────────────────────────────────────────
  function filterWithRetry() {
    RETRY_DELAY.forEach(ms => setTimeout(filterGallery, ms));
  }

  // ── BIND EVENTS ──────────────────────────────────────────────────
  function bindEvents() {
    // 1. Change event on variant wrappers
    document.addEventListener('change', function (e) {
      const inVariant =
        e.target.closest('variant-selects') ||
        e.target.closest('variant-radios');
      if (!inVariant) return;
      filterWithRetry();
    });

    // 2. Dawn custom events (all known names across versions)
    ['variant:change', 'on:variant:change', 'theme:variant:change'].forEach(name => {
      document.addEventListener(name, filterWithRetry);
    });

    // 3. Dawn internal pub/sub
    if (typeof subscribe === 'function') {
      try { subscribe('variant:change', filterWithRetry); } catch (_) {}
    }

    // 4. MutationObserver on hidden variant input
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      new MutationObserver(function () {
        filterWithRetry();
      }).observe(variantInput, { attributes: true, subtree: true, characterData: true });
    }

    // 5. Direct click on swatch/pill labels
    document.querySelectorAll('variant-selects label, variant-radios label').forEach(label => {
      label.addEventListener('click', filterWithRetry);
    });
  }

  // ── INIT ─────────────────────────────────────────────────────────
  function init() {
    filterGallery();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
